import { valueWritable } from "..";

export function createScope<ScopeId extends string>() {
    /////////////////////////////
    ///      SCOPE            ///
    const stack = [ "all" ] as (ScopeId | "all")[];
    const $scope = valueWritable("all");
    const scopeStack = {
        stack,
        push: (scope: ScopeId) => {
            stack.push(scope);
            $scope.set(scopeStack.top());
        },
        pop: (scope: ScopeId) => {
            let index = stack.indexOf(scope);
            if (index === -1) throw new Error("Scope not found");
            stack.splice(index, 1);

            $scope.set(scopeStack.top());
        },
        top: () => stack.at(-1) as ScopeId | "all",
    };

    /////////////////////////////
    ///    ACTIONS            ///
    function nodeScope(node: Node, scope: ScopeId) {
        scopeStack.push(scope);

        return {
            destroy() {
                scopeStack.pop(scope);
            },
        };
    }

    function mouseScope(node: Node, scope: ScopeId) {

        function onMouseEnter() {
            scopeStack.push(scope);
            node.addEventListener("mouseleave", onMouseLeave);
        }

        function onMouseLeave() {
            scopeStack.pop(scope);
        }

        node.addEventListener("mouseenter", onMouseEnter);

        return {
            destroy() {
                node.removeEventListener("mouseenter", onMouseEnter);
                node.removeEventListener("mouseleave", onMouseLeave);
            },
        };
    }

    function keyboardScope(node: Node, scope: ScopeId) {
        function onFocus() {
            scopeStack.push(scope);
            node.addEventListener("blur", onBlur);
        }

        function onBlur() {
            scopeStack.pop(scope);
        }

        node.addEventListener("focus", onFocus);

        return {
            destroy() {
                node.removeEventListener("focus", onFocus);
                node.removeEventListener("blur", onBlur);
            },
        };
    }

    function isScope(scope: ScopeId) {
        return scopeStack.top() === scope;
    }

    function setScope(scope: ScopeId) {
        scopeStack.push(scope);
        return () => scopeStack.pop(scope);
    }

    return {
        isScope,
        setScope,
        scopeStack,
        $scope,

        actions: {
            nodeScope,
            mouseScope,
            keyboardScope,
        }
    };
}
